import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './components/App'
import './index.css'
import './i18n/index'
import './utils/disableConsoleInProd'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
// TODO: Add error boundary